import { combineReducers }  from 'redux-immutablejs';
import products             from '../../../app/domain/products/reducer';
import account              from '../../../app/domain/sign-in/reducer';
import blog                 from '../../../app/domain/blog/reducer';

export default combineReducers({
    products,
    account,
    blog
});